const en = {
    // ─── Navbar ───
    nav: {
        home: 'Home',
        games: 'Game Services',
        marketplace: 'Marketplace',
        portfolio: 'Portfolio',
        news: 'News',
        live: 'Live',
        dashboard: 'Dashboard',
        history: 'History',
        orderHistory: 'Order History',
        login: 'Login',
        register: 'Sign Up',
        loginOrRegister: 'Login / Sign Up',
        loginToStart: 'Login to get started',
        logout: 'Logout',
        jobs: 'Job Board',
    },

    // ─── Hero Section ───
    hero: {
        badge: '#1 Gaming Marketplace in SEA',
        titleLine1: 'Level Up Your Gaming',
        titleLine2: 'with Our Professional Team at',
        titleBrand: 'Fastlane Lv.',
        subtitleLine1: 'Buy & sell legendary items, power leveling services, and premium game accounts',
        subtitleLine2: 'with a professional team of over 30 years of experience',
        searchPlaceholder: 'Search for games, items, or services...',
        searchButton: 'Search',
        trustBadge1: 'Money-back Guarantee',
        trustBadge2: 'Fast Delivery',
        trustBadge3: 'Professional Team',
        sponsorLabel: 'Official Sponsor',
        sponsorsLabel: 'Official Sponsors',
        sponsorTagline: 'Brands that trust and support Fastlane Lv.',
        sponsorVisit: 'Visit store',
        sponsorLogoAlt: 'Sponsor logo',
    },

    // ─── Home Page ───
    home: {
        recommended: 'Latest Recommendations',
        marketplace: 'Marketplace',
        services: 'Recommended Game Services',
        servicesDesc: 'Covering all needs from professional gamers',
        viewAll: 'View All',
        viewAllShort: 'View All',
        viewDetails: 'View Details',
        startingPrice: 'Starting at',
        price: 'Price',
        gameAccount: 'Account',
        gameItem: 'Item',
        chooseService: 'Choose the Right Service for You',
    },

    // ─── Stats Section ───
    stats: {
        whyChoose: 'Why Choose',
        trustedPlatform: 'The platform gamers trust',
        totalMembers: 'Total Members',
        realUsers: 'Real users',
        completedOrders: 'Completed Orders',
        successfulTx: 'Successful transactions',
        supportedGames: 'Supported Games',
        popularGames: 'Popular games',
        satisfaction: 'Satisfaction',
        fromRealReviews: 'From real reviews',
    },

    // ─── Reviews Section ───
    reviews: {
        badge: '⭐ Verified User Reviews',
        title: 'Customer Testimonials',
        subtitle: '{count} reviews from real users nationwide',
        fromReviews: 'From {count} reviews',
        dateLocale: 'en-US',
    },

    // ─── Footer ───
    footer: {
        desc1: 'Game item trading platform',
        desc2: 'and full gaming services',
        desc3: 'Safe, fast, reliable',
        allGames: 'All Games',
        gameAccounts: 'Game Accounts',
        itemsAndSkins: 'Items & Skins',
        boostingService: 'Boosting Service',
        marketplaceTitle: 'Marketplace',
        communityTitle: 'Community',
        contactUs: 'Contact Us',
        faq: 'FAQ',
        available247: 'Available 24/7',
        serverStatus: 'Server Status: Online',
        allRightsReserved: '© 2025 FASTLANE LV Co., Ltd.',
    },

    // ─── Games Page ───
    gamesPage: {
        title: 'All Game Services',
        subtitle: 'Choose the game you want',
        search: 'Search games...',
        allGames: 'All Games',
        noResults: 'No games found',
        badge: 'Game Services',
        heroTitle1: 'All Game',
        heroTitle2: 'Services',
        heroDesc: 'Choose the game you want and we will take care of it for you. Covering all popular games.',
        searchPlaceholder: 'Search game name...',
        trustGuarantee: 'Money-back Guarantee',
        trustFast: 'Fast Delivery',
        trustVerified: 'Professional Team',
        searchResults: 'Search results for',
        gamesCount: 'games',
        matchSearch: 'matching your search',
        viewService: 'View Services',
        showMore: 'Show More',
        remaining: 'games remaining',
        noGames: 'No Games Found',
        noGamesFor: 'No games matching',
        clearSearch: 'Clear Search',
    },

    // ─── Marketplace ───
    marketplacePage: {
        title: 'Marketplace',
        subtitle: 'Buy & sell items, accounts, and services',
        filter: 'Filter',
        allTypes: 'All',
        account: 'Account',
        item: 'Item',
        search: 'Search products...',
        noItems: 'No items found',
        available: 'Available',
        sold: 'Sold',
        reserved: 'Reserved',
        contactSeller: 'Contact Seller',
        // Detail page
        price: 'Price',
        description: 'Description',
        details: 'Details',
        game: 'Game',
        type: 'Type',
        status: 'Status',
        listedDate: 'Listed Date',
        shareTo: 'Share to',
        copyLink: 'Copy link',
        copied: 'Copied!',
        contactLine: 'Buy This Product',
        proposePrice: 'Make an Offer',
        loginToBuy: 'Login to contact seller',
        trustSafe: '100% Safe',
        trustInsured: 'Insured',
        trustSupport: 'Support 24/7',
        verifiedTitle: 'Verified',
        verifiedDesc: 'All products are verified and certified by the Fastlane Lv. team.',
        deliveryTitle: 'Instant Delivery',
        deliveryDesc: 'Product info delivered instantly after payment. No waiting.',
        warrantyTitle: 'Warranty',
        warrantyDesc: 'All products come with warranty. Contact support team anytime for issues.',
        noItemFound: 'Product Not Found',
        noItemFoundDesc: 'This product may have been removed or does not exist.',
        backToMarketplace: 'Back to Marketplace',
        relatedItems: 'You may also like',
        marketplace: 'Marketplace',
        // Sidebar filters
        filterTitle: 'Filters',
        filterReset: 'Reset',
        searchPlaceholder: 'Search products...',
        allGames: 'All Games',
        category: 'Category',
        categoryAll: 'All',
        categoryAccount: 'Game ID / Account',
        categoryItem: 'Items & Skins',
        priceRange: 'Price Range (฿)',
        priceMin: 'Min',
        priceMax: 'Max',
        showing: 'Showing',
        items: 'items',
        sortNewest: 'Newest',
        sortPriceLow: 'Price: Low-High',
        sortPriceHigh: 'Price: High-Low',
        noProducts: 'No Products',
        noProductsDesc: 'No products match your criteria',
        clearFilters: 'Clear all filters',
        viewDetail: 'View Details',
        heroTitle: 'Marketplace',
        heroDesc: 'Buy & sell game IDs, items, and services from popular games, verified by Fastlane Lv.',
    },

    // ─── Portfolio ───
    portfolioPage: {
        title: 'Our Portfolio',
        subtitle: 'View our past work',
        badge: 'Portfolio Showcase',
        heroDesc: 'A collection of all our proud work, including photos and videos from serving hundreds of customers.',
        photoAlbums: 'Photo Albums',
        totalPhotos: 'Total Photos',
        videoAlbums: 'Video Albums',
        totalVideos: 'Total Videos',
        photosTab: 'Photo Gallery',
        videosTab: 'Video Gallery',
        noPhotoAlbums: 'No photo albums yet',
        noVideoAlbums: 'No video albums yet',
        photos: 'photos',
        videos: 'videos',
        clickViewPhotos: 'Click to view all photos',
        clickViewVideos: 'Click to view all videos',
        showing: 'Showing',
        of: 'of',
        albums: 'albums',
    },

    // ─── News ───
    newsPage: {
        title: 'News',
        subtitle: 'Latest updates',
        readMore: 'Read More',
        badge: 'News',
        heroTitle: 'News & Updates',
        heroDesc: 'Stay updated with the latest news from Fastlane Lv.',
        noNews: 'No news available at this time',
        readMoreArrow: 'Read More →',
        page: 'Page',
        close: 'Close',
    },

    // ─── Live ───
    livePage: {
        title: 'Live Streaming',
        subtitle: 'Watch live from our team',
        live: 'LIVE',
        offline: 'Offline',
    },

    // ─── Order History ───
    orderHistory: {
        title: 'Order History',
        orderNumber: 'Order #',
        date: 'Date',
        status: 'Status',
        total: 'Total',
        pending: 'Pending',
        processing: 'Processing',
        completed: 'Completed',
        confirmed: 'Confirmed',
        cancelled: 'Cancelled',
        noOrders: 'No order history yet',
    },

    // ─── Jobboard ───
    jobsPage: {
        title: 'Job Board',
        heroDesc: 'Post the job you want done and let our admins pick it up. Ask for a quote, or hire at the budget you set.',
        postJob: '+ Post a job',
        myJobs: 'My jobs',
        tabOpen: 'Open',
        tabActive: 'Taken / In progress',
        tabCompleted: 'Completed',
        statOpen: 'Open',
        statTaken: 'Taken',
        statInProgress: 'In progress',
        statCompleted: 'Completed all-time',
        jobsUnit: 'jobs',
        filterAllGames: 'All games',
        filterAllServices: 'All categories',
        filterAllJobTypes: 'All job types',
        clearFilter: 'Clear filter',
        colJob: 'Job',
        colCategory: 'Category',
        colHireType: 'Hire type',
        colBudget: 'Budget',
        colWhen: 'When',
        colDeliverBy: 'Deliver by',
        colStatus: 'Status',
        loadMore: 'Load more',
        empty: 'No jobs in this tab yet',
        emptyDesc: 'Try another tab or clear the filter',
        loadError: 'Could not load the job board',
        retry: 'Retry',
        comingSoon: 'Job Board coming soon',
        comingSoonDesc: 'Soon you will be able to post the job you want done and have our admins pick it up right away.',
        staffMode: 'Test mode: only staff can see this board; jobs posted now are test jobs',
        offMode: 'The job board is off: customers cannot see this page (staff only)',
        accept: '🙋 Take job',
        viewDetail: 'View details',
        noDeadline: 'Not set',
        safetyNote: 'Pay only into the FASTLANE shop account, and share game account details only in the order chat',
        // Detail page
        back: 'Back to job board',
        closedTitle: 'This job is closed',
        closedDesc: 'This post was closed, cancelled or has expired. Browse other jobs on the board.',
        timeline: 'Progress',
        stepPosted: 'Posted',
        stepTaken: 'Taken',
        stepTakenBy: 'Taken by admin {name}',
        stepTakenTeam: 'Taken by the Fastlane team',
        stepStarted: 'Work started',
        stepCompleted: 'Completed',
        idleNote: 'This job is on hold: no recent activity',
        details: 'Job details',
        descClosed: 'Job details are shown only while the job is open',
        game: 'Game',
        category: 'Category',
        hireType: 'Hire type',
        playMode: 'Play mode',
        rank: 'Rank',
        server: 'Server',
        preferredTime: 'Preferred time',
        budget: 'Budget',
        deliverBy: 'Deliver by',
        poster: 'Client',
        reopened: '♻️ Reopened',
        // My jobs
        myTitle: 'My jobs',
        myDesc: 'Track the review status of your posts, fix rejected ones, cancel a job, or open the chat with the admin who took it',
        myEmpty: 'You have not posted any jobs yet',
        backToBoard: 'Go to job board',
        cancelJob: 'Cancel job',
        goChat: '💬 Open chat',
        pay: '💳 Pay / attach slip',
        repost: 'Post again',
        viewPublic: 'View public post',
        confirmNotPaid: 'I have NOT transferred any money for this job',
        refresh: 'Refresh',
        // Moderation (pending / rejected posts)
        filterOtherGames: 'Other games (named by poster)',
        editPostTitle: 'Edit job post',
        reviewNotice: 'Every post is reviewed by an admin before it appears on the job board',
        statusPending: '⏳ Awaiting admin review',
        statusRejected: '❌ Not approved',
        pendingNote: 'Your post is waiting for an admin review and will appear on the board once approved · it cannot be edited while in review (you can edit it if it is rejected)',
        submittedAt: 'Submitted',
        resubmitCount: 'Resubmitted {n}×',
        rejectReasonTitle: 'Reason it was not approved',
        rejectedHint: 'Tap to edit the post and send it for review again',
        rejectedDeadline: 'Edit and resubmit by {date}, otherwise the post closes automatically',
        reviewedBy: 'Reviewed by',
        editPost: 'Edit post',
        editResubmit: 'Edit & resubmit',
        cancelPost: 'Cancel post',
        moderationHistory: 'Review history',
        modSubmit: 'Submitted',
        modResubmit: 'Edited & resubmitted',
        modApprove: 'Approved',
        modReject: 'Not approved',
    },

    // ─── Partner shops (PartnerBand + /partners) ───
    partners: {
        title: 'Partner Stores',
        subtitle: 'Stores doing business with FASTLANE LV',
        viewAll: 'View all stores',
        visit: 'Visit store',
        empty: 'No partner stores yet.',
        pageTitle: 'Partner Stores - Fastlane Lv.',
        backHome: 'Back to home',
        imageAlt: 'Partner store',
        prev: 'Scroll left',
        next: 'Scroll right',
    },

    // ─── Common ───
    common: {
        loading: 'Loading...',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        confirm: 'Confirm',
        close: 'Close',
        back: 'Back',
        next: 'Next',
        previous: 'Previous',
        search: 'Search',
        noData: 'No data',
    },
};

export default en;
